export default __webpack_public_path__ + "static/media/ampbitext.3c864e07.svg";